import { useSelector } from "react-redux";
import {
  globalDataSelector,
} from "../../../redux/slices/globalDataSlice";
import { useSearchParams } from "react-router-dom";
import useGetSearchParams from "../../../hooks/useGetSearchParams";
import useSetSearchParams from "../../../hooks/useSetSearchParams";
import React, {useEffect, useMemo, useRef, useState} from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import {
  search, status, tier,
} from "../../Authorized/Statistics/IOS/IOSClicksStats/IOSClicksStats";
import s from '../IosCustomerAnalytics/customerAnalytics.module.scss'
import SvgSelector from "../../../components/SvgSelector/SvgSelector";
import CommandsWeeks from "./Tabs/CommandsWeeks/CommandsWeeks";
import { tierOptionsList} from "../../../utils/vars/staticVariables";
import { useTranslation } from "react-i18next";
import Header from "../../../components/Partials/Header/Header";
import MultiSelect from "../../../components/Selects/MultiSelect/MultiSelect";
import GradientBorder from "../../../components/GradientBorder/GradientBorder";
import CommandsMonths from "./Tabs/CommandsMonths/CommandsMonths";
import {useSearchParamsOptions} from "../../../utils/helpers/useSelectHelpers";
import TopClients from "./Tabs/TopClients/TopClients";
import {
  clientsTab,
  commandsMonths,
  commandsWeeks,
  customerAnalyticsTabList
} from "../IosCustomerAnalytics/IosCustomerAnalytics";

// const commandsWeeks = 'commands-weeks'
// const commandsMonths = 'commands-months'
// const clientsTab = 'clients'
//
// const tabList = [
//   {
//     name: "analytics.commands_weeks",
//     icon: "teams-icon",
//     value: commandsWeeks,
//   },
//   {
//     name: "analytics.commands_months",
//     icon: "teams-icon",
//     value: commandsMonths,
//   },
//   {
//     name: "clients",
//     icon: "cup-icon",
//     value: clientsTab,
//   },
// ];

const AndroidCustomerAnalytics = () => {
  const underlineRef = useRef(null);

  const { isCollapsedSidebar } =
    useSelector(globalDataSelector);

  const [searchParams, setSearchParams] = useSearchParams();

  const { search: searchValue, content: contentValue } = useGetSearchParams();

  const updateSearchParams = useSetSearchParams(setSearchParams);

  const { t, i18n } = useTranslation();

  const currentTab = (() => {

    if (customerAnalyticsTabList.find(item => item.value === contentValue)) {
      return contentValue;
    } else {
      return customerAnalyticsTabList[0].value;
    }
  })();

  const [selectedTier] = useSearchParamsOptions(searchParams, [tier]);

  const [inputSearchValue, setInputSearchValue] = useDebounce((value) => {
    if (value) {
      updateSearchParams(search, value);
    } else {
      updateSearchParams(search, value, true);
    }
  }, 600);

  useEffect(() => {
    const activeBtn = document.querySelector(`.${s.active}`);
    if (activeBtn && underlineRef.current) {
      const { left, width } = activeBtn.getBoundingClientRect();
      const parentLeft = activeBtn.parentElement.getBoundingClientRect().left;
      const scrollLeft = activeBtn.parentElement.scrollLeft; // Додаємо врахування скролу

      underlineRef.current.style.width = `${width}px`;
      underlineRef.current.style.transform = `translateX(${left - parentLeft + scrollLeft}px)`;
    }
  }, [currentTab, i18n.language]);

  useEffect(() => {
    if (!searchValue) {
      setInputSearchValue("");
    } else {
      setInputSearchValue(searchValue);
    }
  }, [searchParams]);

  return (
    <div
      className={`${s.balancesWrapper} ${isCollapsedSidebar === "true" ? s.collapsedSidebar : ""}`}
    >

      <Header
          searchValue={inputSearchValue}
          setSearchValue={setInputSearchValue}
          isSearch={currentTab !== clientsTab}
      />
      <div className={s.pageContent}>
        <div className={s.switchPageContentContainer}>
          <div className={s.buttonsContainer}>
            {customerAnalyticsTabList.map(({name, value, icon}) => (
                <button
                    key={name}
                    onClick={() => updateSearchParams("content", value)}
                    className={`${s.pageBtn} ${currentTab === value ? s.active : ""}`}
                >
                  <SvgSelector id={icon}/>
                  {t(name)}
                </button>
            ))}

            <div className={s.underline} ref={underlineRef}></div>
          </div>
        </div>
        <GradientBorder className={s.gradientBorderCustom}/>

        {
            currentTab !== clientsTab && <div className={s.filtersWrapper}>
              <div className={`${s.filters} ${s.oneFilter}`}>
                <div className={s.selectWrapper}>
                  <div className={s.selectIconWrapper}>
                    <SvgSelector id="user-select-icon"/>
                  </div>
                  <MultiSelect
                      isClearable={true}
                      isMulti={true}
                      value={selectedTier}
                      options={tierOptionsList}
                      setSelectedOptions={(values) =>
                          updateSearchParams(
                              tier,
                              values.map((el) => el.value).join(","),
                          )
                      }
                      placeholder='Tier'
                  />
                </div>
              </div>
            </div>
        }

        {currentTab === commandsWeeks && <CommandsWeeks/>}
        {currentTab === commandsMonths && <CommandsMonths/>}
        {currentTab === clientsTab && <TopClients/>}
      </div>
    </div>
  );
};

export default AndroidCustomerAnalytics;
